module.exports = __webpack_public_path__ + "static/media/attachment.98f624bf.svg";